<template>
    <div class="categories ui styled fluid accordion" v-if="rootCategory">
        
        <category-node :userstatus="getuserStatus" :rootCategory="rootCategory" v-for="child in children" :category="child" :level="1" :key="child.id" :searchUrlParams="searchUrlParams"></category-node>

    </div>
</template>

<script>    
import CategoryNode from './CategoryNode'

export default {
    components: {
        CategoryNode
    },
    props: ['rootCategory', 'userstatus', 'searchUrlParams'],
    computed: {
        children() {
            return this.rootCategory.children
        },
		getuserStatus() {
			return this.userstatus;
		}
    },
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CategoryTree.vue